import { ColumnViewModel } from '../../shared/column-types';

export const numberChemsIncludedInEvidenceGDA_SUMMARY: ColumnViewModel = {
  columns: [
    'chemID',
    'chemPrefName',
    'chemNumGDAs',
    'chemNumPublicationsGDA',
    'chemNumPublicationsGDAs',
    'chemNumVDAs',
    'chemNumPublicationsVDAs',
    'chemNumPublications',
  ],
  defaultVisible: [
    'chemPrefName',
    'chemNumGDAs',
    'chemNumPublicationsGDA',
    'chemNumPublicationsGDAs',
    'chemNumVDAs',
    'chemNumPublicationsVDAs',
  ],
};